<template>
	<div class="page">
    <div class="tips-box" >
      <span class="red-txt">系统提示：</span>
      <span>
        本系统建议使用谷歌浏览器、360浏览器(极速模式)。如您的浏览器版本较低,建议做相应的升级。如登录后页面显示不全,请调整浏览器缩放比例到100%。
      </span>
    </div>
    <div class="login-section">
      <div class="login">
        <TeacherLogin></TeacherLogin>
      </div>
		</div>
	</div>
</template>
<script>
import TeacherLogin from "./components/TeacherLogin"
export default {
	components: { TeacherLogin },
	inject: ['reload'],
	data() {
		return {
			tabActive: 'teacher',
		}
	},
	created() {},
	watch: {
		//监听路由地址的改变
		$route: {
			immediate:true,
			handler(newValue){
				console.log('newValue', newValue);
				if (newValue.query.action) {
					let tabActive = newValue.query.action
					if (tabActive && ['student', 'teacher'].includes(tabActive)) {
						this.tabActive = tabActive
					}
				}
			}
		}
	},

	methods: {

	},
}
</script>

<style lang="stylus" scoped>
.page
  display flex
  justify-content center
  align-items center
  flex-direction column
  background url('~@/assets/images/login-bg.png')
  background-repeat no-repeat
  background-position center
  height 100%
  background-size cover
.tips-box {
  padding: 30px 0;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  word-break: break-all;
  word-wrap: break-word;
  .red-txt {
    color: red;
  }
}
.login-section {
  display flex
  justify-content center
  align-items center
  padding-bottom 30px
}
.login
	uiBlock();
	display flex
	justify-content center
	flex-direction column
	padding 71px 140px 71px 140px
	margin: 10px 0;
.t1s {
	width: 1440px;
	min-width: 1440px;
	margin: auto;
	padding: 0;
}

.t1s .ipt {
	width: 260px;
	border-radius: 5px;
	background-color: coral;
	color: #fff;
	text-align: center;
	border: 1px solid transparent;
	font-weight: 900;
	margin-top: 10px;
	margin-left: 60px;
}

.t1s #tab-first {
	width: 720px;
	text-align: center;
}

.t1s #tab-second {
	width: 720px;
	text-align: center;
}

.t1s input {
	border: 1px #68696a solid;
	border-radius: 5px;
	height: 35px;
}

#tpl_for_iframe {
	margin-left: 40%;
}
#pwd{
	height: 35px;
	margin-top: 20px;
}

</style>
